import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber7Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"number-7-square, key"} maskId="square-filled-radius-0-stroke-1-IconNumber7Square"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM9.15234 7.79492V8.73828H13.6758V8.82031L9.87891 16.25H10.9863L14.748 8.77344V7.79492H9.15234Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNumber7Square;
